import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PIconModule } from '@panaya/ui/p-icon';
import { PButtonComponent } from './p-button.component';
import { PipeModule } from '@panaya/ui/pipes';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [PButtonComponent],
    imports: [CommonModule, PIconModule, PipeModule, MatTooltipModule, PipeModule],
    exports: [PButtonComponent]
})
export class PButtonModule {}
